var map = {
	"./black/fenzuhanhua2.png": "W3E1",
	"./blue/fenzuhanhua2.png": "SlwV",
	"./white/fenzuhanhua2.png": "vnMc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DuYY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/fenzuhanhua2\.png$
// module id = DuYY
// module chunks = 24